import { render, staticRenderFns } from "./SecondStep.vue?vue&type=template&id=6b9a5bc8&"
import script from "./SecondStep.vue?vue&type=script&lang=js&"
export * from "./SecondStep.vue?vue&type=script&lang=js&"
import style0 from "./SecondStep.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports